/**
 * Logger conditionnel : n'écrit dans la console qu'en environnement de
 * développement. En production (NODE_ENV === 'production'), c'est un no-op.
 *
 * Usage :
 *   import { logger } from "@/lib/logger";
 *   logger.error("Erreur fetch", err);
 *   logger.info("Submitted", payload);
 */

const isDev = process.env.NODE_ENV !== "production";

const noop = () => {};

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: isDev ? console.error.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
};
